var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq15(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.548047,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7844,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.3719,
    y1: 12.1824,
    x2: 49.6082,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.698024,
    y1: 49.8543,
    x2: 11.9343,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.134,
    y1: 38.6199,
    x2: 49.3703,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.460179,
    y1: 0.944118,
    x2: 11.6965,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.434 21.844V20.962H21.814V31H20.82V21.844H19.434ZM30.3259 21.802H25.2019V25.386C25.4352 25.0593 25.7759 24.7933 26.2239 24.588C26.6719 24.3733 27.1572 24.266 27.6799 24.266C28.4452 24.266 29.0706 24.4247 29.5559 24.742C30.0412 25.05 30.3912 25.456 30.6059 25.96C30.8206 26.4547 30.9279 26.9867 30.9279 27.556C30.9279 28.2093 30.8019 28.802 30.5499 29.334C30.3072 29.8567 29.9292 30.272 29.4159 30.58C28.9119 30.888 28.2819 31.042 27.5259 31.042C26.5646 31.042 25.7852 30.7947 25.1879 30.3C24.5906 29.796 24.2266 29.1193 24.0959 28.27H25.0619C25.1832 28.886 25.4632 29.362 25.9019 29.698C26.3406 30.034 26.8819 30.202 27.5259 30.202C28.3379 30.202 28.9492 29.964 29.3599 29.488C29.7799 29.0027 29.9899 28.3633 29.9899 27.57C29.9899 26.7953 29.7799 26.1933 29.3599 25.764C28.9399 25.3253 28.3379 25.106 27.5539 25.106C27.0126 25.106 26.5366 25.232 26.1259 25.484C25.7152 25.736 25.4119 26.0767 25.2159 26.506H24.2919V20.948H30.3259V21.802Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq15);
export default __webpack_public_path__ + "static/media/fq15.4fe86f9fd1438857fb5b87103e37a510.svg";
export { ForwardRef as ReactComponent };